/* src/app/pages/index/index.component.scss */
/*# sourceMappingURL=index.component.css.map */
